import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";
import { EmployeeCacheService } from '../../core/services/employee-cache.service';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {

  constructor(
    private employeeCacheService: EmployeeCacheService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const modifiedRequest = request.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': environment.ocpApimSubscriptionKey,
        'x-user-id': this.employeeCacheService.uid || ""
      }
    })
    return next.handle(modifiedRequest);
  }
}
